import { JsonMapper } from '../modules/mapper/json.mapper';
import { TransferHttp } from '../modules/transfer-http/transfer-http';
import { UtilHelper } from '../helpers/util.helper';
import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { BaseService } from './base.service';
import { PaginationModel, PostModel, ResponseModel } from '../models';
import { REST_API } from '../modules/constants';

@Injectable()
export class PostService extends BaseService {

    constructor(public http: TransferHttp) {
        super(http);
    }

    /**
     * Get list variable
     * @returns {Promise<T>|Promise<U>}
     */
    public findAll(paging: boolean = true, filter: any = {}): Promise<PaginationModel> {

        if (!paging) {
            filter.offset = '';
            filter.limit = '';
        }
        const queryString = UtilHelper.parseFilterToString(filter);
        return this.makeHttpGet(`${this.apiUrl}/` + REST_API.POST + '?' + queryString)
            .then((res) => {
                res.data = JsonMapper.deserialize(PostModel, res.data);
                return res;
            });
    }

      /**
     * Get detail
     * @param id
     */
    public findById(id: string): Promise<PostModel> {
        return this.makeHttpGet(`${this.apiUrl}/${REST_API.POST}/${id}`)
            .then((res) => {
                return JsonMapper.deserialize(PostModel, res);
            });
    }

    /**
     * Create
     * @param data
     */
    public create(data: PostModel): Promise<ResponseModel> {
        return this.makeHttpPost(`${this.apiUrl}/${REST_API.POST}`, JsonMapper.serialize(data));
    }
    /**
     * Update
     * @param data
     */

    public update(data: PostModel): Promise<ResponseModel> {
        return this.makeHttpPut(`${this.apiUrl}/${REST_API.POST}/${data.id}`, JsonMapper.serialize(data));
    }

    public delete(id: string): Promise<ResponseModel> {
        return this.makeHttpDelete(`${this.apiUrl}/${REST_API.POST}/${id}`);
    }
}